import styles from "@styles/Login.module.scss";
import { Text, Button, ButtonGroup } from "@eventsquare/uikit";
import {
  Form,
  FormLabel,
  FormInput,
  FormFieldset,
  FormGroup,
} from "@eventsquare/uikit/forms";
import * as yup from "yup";
import { useNavigate } from "react-router-dom";

interface LoginFormValues {
  email: string;
  password: string;
}

const initialValues: LoginFormValues = {
  email: "",
  password: "",
};

const validationSchema = yup.object({
  email: yup
    .string()
    .email("Please provide a valid email")
    .required("Please provide an email"),
  password: yup
    .string()
    .min(8, "Password should be at least 8 characters")
    .required("Please provide a password"),
});

const Login = () => {
  const navigate = useNavigate();

  const handleSubmit = (values: LoginFormValues) => {
    navigate("/dashboard");
    console.log("LOGGED IN", values);
  };

  return (
    <div className={styles.content}>
      <div className={styles.body}>
        <Text variant="h1">Login</Text>
        <div className={styles.form}>
          <Form
            onSubmit={handleSubmit}
            initialValues={initialValues}
            validationSchema={validationSchema}
          >
            <FormFieldset>
              <FormGroup>
                <FormLabel htmlFor="email">E-mail</FormLabel>
                <FormInput
                  name="email"
                  type="email"
                  placeholder="johndoe@eventsquare.co"
                />
              </FormGroup>
              <FormGroup>
                <FormLabel htmlFor="password">Password</FormLabel>
                <FormInput
                  name="password"
                  type="password"
                  placeholder="Fill in your password"
                />
              </FormGroup>
            </FormFieldset>
            <ButtonGroup>
              <Button type="submit">Login</Button>
              <Button type="button" variant="link" color="primary">
                Forgot password?
              </Button>
            </ButtonGroup>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default Login;
